import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
  docsToSign: [],
  requestVerificationToken: false,
};

const electronicSignatureCreationSlice = createSlice({
  name: 'electronicSignatureCreation',
  initialState,
  reducers: {
    setElectronicSignatureCreationState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetElectronicSignatureCreationState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const {
  setElectronicSignatureCreationState,
  resetElectronicSignatureCreationState,
} = electronicSignatureCreationSlice.actions;

export default electronicSignatureCreationSlice.reducer;
